import React from 'react';
import { Button, Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import AbstractMachine from './abstractMachine';

export default class CheckingEmail extends AbstractMachine {
  constructor(form, goTo) {
    super(form, goTo);

    this._name = 'checkingEmail';
    this._nextState = 'passwd';
  }

  render(props) {
    return (
      <>
        {this.getMainInput(props)}
        <Form.Item className="width100">
          <Button type="primary" className="ant-btn-primary width100">
            <span>
              <FormattedMessage id="Checking" defaultMessage="Checking" />
              &nbsp;&hellip;
            </span>
          </Button>
        </Form.Item>
      </>
    );
  }
}
